import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    titleContainer: {
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
    },
    formSubtitle: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "20px",
        color: theme.palette.secondary.dark,
        margin: "0",
    },
    formTitle: {
        fontFamily: "Open Sans !important",
        fontWeight: "600 !important",
        color: theme.palette.secondary.dark,
        fontSize: "32px !important",
    },
    fieldsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
        justifyContent: "center",
        alignItems: "center",
    },
    select: {
        textAlign: "left",
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    submitButton: {
        "&.MuiButtonBase-root": {
            background: theme.palette.info.light,
            color: "white",
            height: "36px !important",
            fontFamily: "Open Sans",
            marginBottom: "30px",
            "&:hover": {
                background: theme.palette.info.light,
            },
        },
    },
    cancelButton: {
        marginRight: `${theme.spacing(5)} !important`,
        "&.MuiButtonBase-root": {
            height: "36px !important",
            fontFamily: "Open Sans",
            marginBottom: "30px",
        },
    },
    listContainer: {
        "&.MuiList-root": {
            paddingTop: 0,
        },
        width: "100%",
    },
    listItem: {
        display: "flex",
        marginBottom: "10px",
    },
    listText: {
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: 600,
            color: theme.palette.secondary.dark,
        },
    },
    chips: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
        "&.MuiFormControl-root .MuiInputBase-root .MuiChip-root": {
            background: "#247BA0",
            color: "white",
        },
        "&.MuiFormControl-root .MuiInputBase-root .MuiChip-root .MuiChip-deleteIcon": {
            color: "white",
        },
    },
    separator: {
        paddingBottom: "20px",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
    },
    error: {
        color: `${theme.palette.error.main} !important`,
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: theme.spacing(1.25),
        },
    },
    avatar: {
        width: `120px !important`,
        height: `120px !important`,
    },
    noAdminsWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    listItemContainer: {
        display: "flex",
        gap: theme.spacing(2),
    },
    listContainerTitle: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "16px",
        color: theme.palette.secondary.dark,
        margin: 0,
    },
    listContainerEmail: {
        fontFamily: "Open Sans",
        fontWeight: 400,
        fontSize: "16px",
        color: theme.palette.secondary.dark,
        margin: 0,
    },
    separatorNoPadding: {
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
        width: "100%",
    },
    addAdminActions: {
        display: "flex",
        alignItems: "center",
        width: "100%",
    },
}));
